import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { Variables } from '@pages/fabrica-credito/interfaces/variables';
import { RangosComponent } from '@pages/rangos/rangos.component';
import { OpcionesService } from '@p-p-portafolio/services/opciones.service';
import { PerfilService } from '@pages/perfil/services/perfil.service';
import { SwalService } from '@shared/utils/swal.service';
import { VariablesService } from '../services/variables.service';

@Component({
  selector: 'app-variables-form',
  templateUrl: './variables-form.component.html',
  styleUrls: ['./variables-form.component.css'],
})
export class VariablesFormComponent implements OnInit {
  @Input() modelRecived: Variables;
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];
  public loading: boolean;
  optionSlect: string;
  private readonly _width: string = '900px';
  cliente: boolean;
  cutoff: Boolean;
  empresa: boolean;
  opciones: OpcionesRequest;
  comboTipo: boolean;
  comboCampo: boolean;
  campoOpciones: any[] = [];
  campoTipos: any[] = [];
  opcionesRequestModel: OpcionesRequest;
  comboPop: boolean;
  fechaEdo: boolean;
  campoProc: boolean;

  //#region Booleanos
  //#endregion

  constructor(
    private _fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<VariablesFormComponent>,
    private _swalService: SwalService,
    private _perfilService: PerfilService,
    private _variablesService: VariablesService,
    private _opcionesService: OpcionesService,
    public _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public model: Variables
  ) {
    if (this.model !== null) {
      this.modelRecived = model;
      const setModel = {
        clavePerfil: model.clavePerfil,
        variable: model.variable,
        tabla: model.tabla,
        tipo: model.tipo,
        campo: model.campo,
        fechaEdo1: model.fechaEdo1,
        fechaEdo2: model.fechaEdo2,
        user: '',
      };
      this.form.setValue(setModel);
    }
  }

  ngOnInit() {
    this.onBreakPonit();
    this.getOptions();
  }

  form = this._fb.group({
    clavePerfil: [''],
    variable: [''],
    tabla: [''],
    tipo: [''],
    campo: [''],
    fechaEdo1: [''],
    fechaEdo2: [''],
    user: [''],
  });

  getOptions() {
    this.opcionesRequestModel = {
      tabla: 'variables',
      campo: 'tabla',
    };
    this._variablesService
      .opciones(this.opcionesRequestModel)
      .subscribe((res) => {
        this.opciones = res.data;
      });
  }

  //#region ChangeForm
  create(model: Variables) {
    if (this.form.valid) {
      model.user = JSON.parse(sessionStorage.getItem('Usser'));
      this.loading = true;
      this._variablesService.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else
          this._swalService.error(
            'No Agregado, Puede ser que la clave ya exista, valide con una diferente por favor!'
          );
      });
    }
  }

  update(model: Variables) {
    sessionStorage.setItem('variable', JSON.stringify(model.variable))
    if (this.form.valid) {
      this.loading = true;
      this._variablesService.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }
  //#endregion

  //#region Options

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }

  onChangeSelect(ob) {
    if (ob.value === 'Cliente') {
      this.comboCampo = true;
      this.clienteOptions();
    } else if (ob.value === 'CutOff') {
      this.cutOffOptions();
      this.comboCampo = true;
    } else if (ob.value === 'Empresa') {
      this.comboCampo = true;
      this.comboTipo = false;
      this.empresaOptions();
    } else if (ob.value === 'Finanzas') {
      this.comboCampo = true;
      this.fechaEdo = true;
      this.comboPop = false;
      this.comboTipo = false;
      this.finanzasOptions();
    } else if (ob.value === 'Garantia') {
      this.comboCampo = true;
      this.garantiaOptions();
    } else if (ob.value === 'Producto') {
      this.comboCampo = true;
      this.productoOptions();
    } else if (ob.value === 'POP') {
      this.comboCampo = false;
      this.comboPop = true;
      this.popOptions();
    } else if (ob.value === 'Empleo') {
      this.comboTipo = true;
      this.comboCampo = true;
      this.comboPop = false;
      this.empleoOptions();
    } else if (ob.value === 'Procedimiento') {
      this.comboTipo = true;
      this.comboCampo = false;
      this.comboPop = false;
      this.campoProc = true;
      this.fechaEdo = false;
      this.procedimientoOptions();
    }else if (ob.value === 'Propiedades') {
      this.comboTipo = true;
      this.comboCampo = true;
      this.comboPop = false;
      this.campoProc = false;
      this.fechaEdo = false;
      this.propiedadesOptions();
    }
    else if (ob.value === 'Propiedades Garantia') {
      this.comboTipo = true;
      this.comboCampo = true;
      this.comboPop = false;
      this.campoProc = false;
      this.fechaEdo = false;
      this.propiedadesGarantiaOptions();
    }
  }

  procedimientoOptions() {
    this.campoTipos = [
      { valor: 'numeric', opcion: 'Numeric' },
      { valor: 'alfaNumeric', opcion: 'Alfanumeric' },
    ];
  }

  cutOffOptions() {
    this.campoOpciones = [{ valor: 'scoring', opcion: 'Scoring' }];
  }

  garantiaOptions() {
    this.campoOpciones = [{ valor: 'withoutField', opcion: 'Without Field' }];
  }

  empresaOptions() {
    this.campoOpciones = [
      { valor: 'size', opcion: 'Size' },
      { valor: 'clienType', opcion: 'Clien Type' },
      { valor: 'type', opcion: 'Type' },
      { valor: 'activity', opcion: 'Activity' },
      { valor: 'employees', opcion: 'Employees' },
      { valor: 'company', opcion: 'Company' },
      { valor: 'nationality', opcion: 'Nationality' },
      { valor: 'antiquity', opcion: 'Antiquity' },
    ];
  }

  clienteOptions() {
    this.campoOpciones = [
      { valor: 'firstName', opcion: 'First Name' },
      { valor: 'firstLastName', opcion: 'First Last Name' },
      { valor: 'age', opcion: 'Age' },
      { valor: 'materialStatus', opcion: 'Material Status' },
      { valor: 'sex', opcion: 'Employees' },
      { valor: 'indebtendness', opcion: 'Indebtendness' },
      { valor: 'endDirect', opcion: 'End. Direct' },
      { valor: 'dependents', opcion: 'Dependents' },
      { valor: 'thelephone1', opcion: 'Thelephone 1' },
      { valor: 'thelephone2', opcion: 'Thelephone 2' },
      { valor: 'educationLevel', opcion: 'Education Level' },
      { valor: 'nationality', opcion: 'Nationality' },
      { valor: 'identification', opcion: 'Identification' },
      { valor: 'title', opcion: 'Title' },
      { valor: 'clientType', opcion: 'Client Type' },
      { valor: 'type', opcion: 'Type' },
    ];
  }

  productoOptions() {
    this.campoOpciones = [
      { valor: 'requested', opcion: 'Requested' },
      { valor: 'branch', opcion: 'Branch' },
      { valor: 'userProfile', opcion: 'User Profile' },
      { valor: 'motive', opcion: 'Motive' },
      { valor: 'requestedTerm', opcion: 'Requested/Term' },
      { valor: 'egresosIngresos', opcion: 'Egresos/Ingresos' },
      { valor: 'score', opcion: 'Score' },
      { valor: 'productType', opcion: 'Product Type' },
      { valor: 'classifier', opcion: 'Classifier' },
      { valor: 'currency', opcion: 'Currency' },
      { valor: 'destiny', opcion: 'Destiny' },
      { valor: 'capacity', opcion: 'Capacity' },
      { valor: 'term', opcion: 'term' },
      { valor: 'termAge', opcion: 'Term+Age' },
      { valor: 'type', opcion: 'Type' },
      { valor: 'rate', opcion: 'Rate' },
      { valor: 'downPayment', opcion: 'Down Payment' },
      { valor: 'engancheSolicitado', opcion: 'Enganche/Solicitado' },
      { valor: 'monthlyPayment', opcion: 'Monthly Payment' },
    ];
  }

  finanzasOptions() {
    this.campoOpciones = [
      { valor: 'withoutField', opcion: 'Without Field' },
      { valor: 'variable', opcion: 'Variable' },
      { valor: 'comparisonVariable', opcion: 'Comparision Variable' },
      { valor: 'available', opcion: 'Available' },
      { valor: 'stateSelection', opcion: 'State Selection' },
      { valor: 'sector', opcion: 'Sector' },
    ];
  }

  popOptions() {
    this._perfilService.read().subscribe((res) => {
      this.campoOpciones = res.data;
    });
  }

  empleoOptions() {
    this.opcionesRequestModel = {
      tabla: 'cmtbl_empleos',
      campo: 'tipo_ingreso',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res: any) => {
        debugger;
        this.campoTipos = res.data;
      });
  }

  propiedadesOptions() {
    this.opcionesRequestModel = {
      tabla: 'cmtbl_propiedades',
      campo: 'tipo_propiedad',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res: any) => {
        this.campoTipos = res.data;
      });
  }

  propiedadesGarantiaOptions() {
    this.opcionesRequestModel = {
      tabla: 'cmtbl_propiedades',
      campo: 'clasificacion',
    };
    this._opcionesService
      .loadCombos(this.opcionesRequestModel)
      .subscribe((res: any) => {
        this.campoTipos = res.data;
      });
  }

  openRangos() {
    const dialogRef = this._dialog.open(RangosComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }
}
